import { Any } from "@cede/types";

export type Newable<T> = { new (...args: Any[]): T };
